import{logger as e}from"@sonos-inc/www-server/utils/logger";const o=()=>{e.warn("Not Implemented")};export{o as NotImplementedFunction};
